import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import ContactUsLink from 'components/ui/contact-us-link'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import styles from './index.module.css'

type Props = {
  enterprise_track_allowance: number | null | undefined
  enterprise_user_allowance: number | null | undefined
}

const LitePlanUpdateModal = ({
  enterprise_track_allowance,
  enterprise_user_allowance,
}: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onRequestClose = () => {
    navigate('/settings/billing')
  }

  return (
    <ModalWindow
      header={<Heading size={600}>Contact us to upgrade</Heading>}
      width="medium"
      onClose={onRequestClose}
      isOpen
    >
      <p className={styles.litePlanUpdateModalDescription}>
        Your Lite plan has a limit of {enterprise_user_allowance} user and{' '}
        {enterprise_track_allowance} tracks. To add more users or tracks you’ll
        need to upgrade your plan. View pricing options{' '}
        <a
          className="text-link"
          href="https://disco.ac/pricing"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        , and to upgrade{' '}
        <ContactUsLink
          className="text-link"
          intercomMsg="I’d like to change plan from Lite"
        >
          contact support
        </ContactUsLink>
        .
      </p>
    </ModalWindow>
  )
}

export default LitePlanUpdateModal
